import { FontIcon, Label, mergeStyleSets, TooltipHost } from "@fluentui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReadonlyField from "../components/DynamicForm/ReadonlyField";
import { IContact } from "../shared/interfaces";
import React, { useEffect, useState } from 'react';
import { useBoolean } from "@fluentui/react-hooks";
import { Contact_Type } from "../shared/enums";



const classNames = mergeStyleSets({
    iconClass: {
        fontSize: 20,
        margin: '0 25px'
    },
    contactInfoGroup: {
        padding: '4px 0px',
    },
    address: {
        height: '20px'
    }

});




export interface ContactInfoProps {
    extraCssClass?: string
    contactCard: IContact
}




const ContactInfo: React.FunctionComponent<ContactInfoProps> = (props) => {
    let [contactCard, setContactCard] = useState<IContact>();
    let [localita, setLocalita] = useState<string>('');
    let [showError, setShowError] = useState<boolean>(false);
    let [showContact, setShowContact] = useState<boolean>(false);
    let [showAddress, setShowAddress] = useState<boolean>(false);



    useEffect(() => {
        if (props.contactCard) {
            let contactCard: IContact = { ...props.contactCard };
            setContactCard(contactCard);
            let provincia: string = contactCard.provincia && contactCard.provincia !== contactCard.localita ? contactCard.provincia : "";
            let localitaInfo: string[] = [contactCard.localita, provincia, contactCard.cap];
            setLocalita(localitaInfo.filter(el => el).join(" - ")); //prende le informazioni sulla località da contactCard, le filtra per rimuovere eventuali valori nulli o undefined e quindi le unisce in una singola stringa separata da " - ".

            setShowError(isAnyPropertiesPopulated(contactCard, ['error']));
            setShowContact(isAnyPropertiesPopulated(contactCard, ['contatto', 'nome', 'cognome', 'iniziali', 'stato', 'provincia', 'localita', 'indirizzo', 'cap', 'telefono1', 'telefono2', 'email1', 'email2', 'denominazione', 'matricola', 'codiceIPA']));
            setShowAddress(isAnyPropertiesPopulated(contactCard, ['stato', 'provincia', 'localita', 'indirizzo', 'cap']));
        }
    }, [props.contactCard]);




    return (
        <React.Fragment>


            {showError && contactCard && contactCard.error &&
                <React.Fragment>
                    <Label>Contatto</Label>
                    <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                        <TooltipHost content="Contatto">
                            <FontIcon aria-label="Contact" iconName="Contact" className={classNames.iconClass} />
                        </TooltipHost>
                        <ReadonlyField fieldInternalName="error" content={contactCard.error} showCopyButton={false}></ReadonlyField>
                    </div>
                </React.Fragment>
            }

            {showContact && !showError &&
                <Label>Contatto</Label>
            }


            {showContact && !showError && contactCard && contactCard.denominazione &&
                <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                    <TooltipHost content="Denominazione">
                        <FontIcon aria-label="Contact" iconName="Contact" className={classNames.iconClass} />
                    </TooltipHost>
                    <ReadonlyField fieldInternalName="denominazione" content={contactCard.denominazione} showCopyButton={true}></ReadonlyField>
                </div>}

            {showContact && !showError && contactCard && !contactCard.denominazione &&
                <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                    <TooltipHost content="Contatto">
                        <FontIcon aria-label="Contact" iconName="Contact" className={classNames.iconClass} />
                    </TooltipHost>
                    <ReadonlyField fieldInternalName="contatto" content={`${contactCard.nome ?? ''} ${contactCard.cognome ?? ''}`} showCopyButton={true}></ReadonlyField>
                </div>}

            {showContact && !showError && contactCard && contactCard.matricola &&
                <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                    <TooltipHost content="Matricola">
                        <FontAwesomeIcon className={classNames.iconClass} icon={{ prefix: 'fal', iconName: 'id-card-clip' }} />
                    </TooltipHost>
                    <ReadonlyField fieldInternalName="matricola" content={contactCard.matricola} showCopyButton={true}></ReadonlyField>
                </div>}

            {showContact && !showError && contactCard && contactCard.codiceIPA &&
                <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                    <TooltipHost content="Codice IPA">
                        <FontAwesomeIcon className={classNames.iconClass} icon={{ prefix: 'fal', iconName: 'buildings' }} />
                    </TooltipHost>
                    <ReadonlyField fieldInternalName="codiceIPA" content={contactCard.codiceIPA} showCopyButton={true}></ReadonlyField>
                </div>}

            {showContact && !showError && contactCard && contactCard.email1 &&
                <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                    <TooltipHost content="Mail">
                        <FontIcon aria-label="Mail" iconName="Mail" className={classNames.iconClass} />
                    </TooltipHost>
                    <ReadonlyField fieldInternalName="email1" content={contactCard.email1} showCopyButton={true}></ReadonlyField>
                </div>}

            {showContact && !showError && contactCard && contactCard.email2 &&
                <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                    <TooltipHost content="Mail">
                        <FontIcon aria-label="Mail" iconName="Mail" className={classNames.iconClass} />
                    </TooltipHost>
                    <ReadonlyField fieldInternalName="email2" content={contactCard.email2} showCopyButton={true}></ReadonlyField>
                </div>}

            {showContact && !showError && contactCard && contactCard.telefono1 &&
                <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                    <TooltipHost content="Telefono">
                        <FontIcon aria-label="Phone" iconName="Phone" className={classNames.iconClass} />
                    </TooltipHost>
                    <ReadonlyField fieldInternalName="telefono1" content={contactCard.telefono1} showCopyButton={true}></ReadonlyField>
                </div>}

            {showContact && !showError && contactCard && contactCard.telefono2 &&
                <div className={`flex flex-row align-items-center ${classNames.contactInfoGroup}`}>
                    <TooltipHost content="Telefono">
                        <FontIcon aria-label="Phone" iconName="Phone" className={classNames.iconClass} />
                    </TooltipHost>
                    <ReadonlyField fieldInternalName="telefono2" content={contactCard.telefono2} showCopyButton={true}></ReadonlyField>
                </div>}

            {showContact && !showError && showAddress && contactCard &&
                <div className={`flex flex-row align-items-start ${classNames.contactInfoGroup}`}>
                    <TooltipHost content="Indirizzo">
                        <FontIcon aria-label="POI" iconName="POI" className={classNames.iconClass} style={{ paddingTop: "5px" }} />
                    </TooltipHost>
                    <div className="flex flex-column align-items-start">
                        <ReadonlyField fieldInternalName="indirizzo" content={contactCard.indirizzo} showCopyButton={true} className={classNames.address}></ReadonlyField>
                        <ReadonlyField fieldInternalName="localita" content={localita} showCopyButton={true} className={classNames.address}></ReadonlyField>
                        <ReadonlyField fieldInternalName="stato" content={contactCard.stato} showCopyButton={true} className={classNames.address}></ReadonlyField>
                    </div>
                </div>}

        </React.Fragment>
    );
}

export default ContactInfo;


function atLeastOnePropertyPopulated(contact: IContact): boolean {
    // Get keys of IContact object excluding 'id'
    const keys = Object.keys(contact).filter(key => key !== 'id');

    // Check if at least one of the properties has a value other than an empty string
    return keys.some(key => contact[key as keyof IContact]?.toString().trim() !== '');
}


function isAnyPropertiesPopulated(contact: IContact, propertyNames: Array<keyof IContact>): boolean {
    if (!contact) {
        return false;
    }
    // Controlla se almeno una delle proprietà specificate ha un valore diverso da una stringa vuota
    return propertyNames.some(propertyName => contact[propertyName] && contact[propertyName]?.toString().trim() !== '');
}
